import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ExtractService } from '../../services/extract.service';
import { LoaderService } from '../../services/loader.service';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  selector: 'app-token-verify',
  standalone: true,
  imports: [],
  templateUrl: './token-verify.component.html',
  styleUrl: './token-verify.component.scss'
})
export class TokenVerifyComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private extractService: ExtractService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService
  ) { }

  async ngOnInit(): Promise<void> {
    this.loaderService.showLoader();

    // Limpa o storage para evitar conflito com tokens/dados antigo
    if (typeof window !== 'undefined') {
      this.localStorageService.clearData();
    }

    // Lê os parâmetros da URL
    const params: Params = await firstValueFrom(this.route.queryParams);

    const token = params['Token'];
    const mostrarHeader = params['MostrarHeader'];
    const authenticated = params['Authenticated'];
    const isAttendant = params['IsAttendant'];
    const isApp = params['IsApp'];

    // Se não houver nenhum parâmetro na URL, redireciona para área aberta
    if (!token && !mostrarHeader && !authenticated && !isAttendant && !isApp) {
      this.localStorageService.add('MostrarHeader', 'true');
      this.router.navigate(['/Authentication'], {
        queryParams: { MostrarHeader: 'true' }
      });
      this.loaderService.hideLoader();
      return;
    }

    // Converte os parâmetros de string para boolean
    const mostrarHeaderBool = mostrarHeader === 'true';
    const authenticatedBool = authenticated === 'true';
    const isAttendantBool = isAttendant === 'true';
    const isAppBool = isApp === 'true';

    // Cenário sem token
    if (!token) {
      // Área aberta com header visível
      if (mostrarHeaderBool && !authenticatedBool) {
        this.localStorageService.add('MostrarHeader', 'true');
        this.router.navigate(['/Authentication'], {
          queryParams: { MostrarHeader: 'true' }
        });
        this.loaderService.hideLoader();
        return;
      }

      // Cenário sem token e sem header: redireciona para not-found
      this.router.navigate(['/not-found']);
      this.loaderService.hideLoader();
      return;
    }

    // Validação do token
    const decoded = this.extractService.getDecodedAccessToken(token);

    if (!decoded) {
      this.router.navigate(['/not-found']);
      this.loaderService.hideLoader();
      return;
    }

    // Persiste os dados necessários no localStorage para os próximos passos da aplicação
    if (typeof window !== 'undefined') {
      this.localStorageService.add('sToken', token);
      this.localStorageService.add('MostrarHeader', mostrarHeaderBool ? 'true' : 'false');
      this.localStorageService.add('IsApp', isAppBool ? 'true' : 'false');
      this.localStorageService.add('IsAttendant', isAttendantBool ? 'true' : 'false');
    }

    // Fluxo e-mail: participante precisa validar dados - CPF/Data de Nasimento
    if (mostrarHeaderBool && !authenticatedBool) {
      this.router.navigate(['/Authentication'], {
        queryParams: { MostrarHeader: 'true', hasToken: 'true' }
      });
      this.loaderService.hideLoader();
      return;
    }

    // Fluxo Atendente: ja autenticado, direciona direto para a home mostrando o header
    if (mostrarHeaderBool && authenticatedBool) {
      this.router.navigate(['/home'], {
        queryParams: { MostrarHeader: 'true' }
      });
      this.loaderService.hideLoader();
      return;
    }

    // Fluxo area restrita: área restrita sem header
    this.router.navigate(['/home']);
    this.loaderService.hideLoader();
  }
}
